import React, { cloneElement } from "react";
import { RCCLov,RCCRefLovProps } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import { useTranslation } from "src/context/Translations/context";
import stringToNumber from "src/utils/stringToNumber";

const LovDimensions: React.ForwardRefRenderFunction<RCCRefLovProps,ILovComponent> = ({
	name,
	control,
	label,
	...rest
},ref) => {
	const { translate } = useTranslation();

	const optionComponent = (component:any,props:any) =>  
		  cloneElement(component,
			props,
			<span 
				style={{
					fontWeight: stringToNumber(props.data.value) < 0 ? "bold":"initial",
					paddingLeft:stringToNumber(props.data.value) < 0 ? 0:30
				}}
			>
				{props.data.value <= 0 ?
					translate(props.data.label)
					:
					props.data.label
				}
			</span>)
		;

	const singleValueComponent = (component:any,props:any) =>  
		cloneElement(component,
		  props,
			props.data.value <= 0 ?
				translate(props.data.label)
				:
				props.data.label
		)
	;

	return(
		<RCCLov 
			label={label}
			name={name} 
			control={control}
			placeholder={translate("Digite para filtrar as opções")}
			extraParametersOnLoad={{
				useConsolidated: true
			}}
			componentsFunctions={{option:(x:any,y:any) => optionComponent(x,y),singleValue:(x:any,y:any) => singleValueComponent(x,y)}}
			ref={ref}
			{...rest}
			elementsPerPage={20}
			routeAPI="Dimensions/Lov"
			valueProperty="Taa011Id"
			labelProperty="Taa011Descricao"
		/>
	);};

export default React.forwardRef(LovDimensions);
